// extracted by mini-css-extract-plugin
export default {"wrapper":"live-queue-badge_wrapper__l7Q6Y"};